import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface CheckVisaBulletinErrorBoundaryProps {
  reset: VoidFunction
}

export const CheckVisaBulletinErrorBoundary = ({ reset }: CheckVisaBulletinErrorBoundaryProps) => {
  return (
    <div className={cn('flex items-center justify-between', 'h-[56px]', 'p-4', 'rounded-md border border-destructive')}>
      <span className={cn('text-sm font-medium leading-5', 'text-destructive')}>An error occurred in visa data</span>
      <Button size="sm" variant="outline" onClick={reset}>
        Retry
      </Button>
    </div>
  )
}
